// 非首屏任务等页面 load 后再占用空闲时间；支持组件卸载取消。
export function afterPageLoad(task, browser = window) {
  let disposed = false, idle, timer;
  const run = () => {
    if (disposed) return;
    if (browser.requestIdleCallback) idle = browser.requestIdleCallback(() => { if (!disposed) task(); }, { timeout: 1500 });
    else timer = browser.setTimeout(() => { if (!disposed) task(); }, 300);
  };
  if (browser.document.readyState === 'complete') run();
  else browser.addEventListener('load', run, { once: true });
  return () => {
    disposed = true;
    browser.removeEventListener('load', run);
    if (idle !== undefined) browser.cancelIdleCallback?.(idle);
    if (timer !== undefined) browser.clearTimeout(timer);
  };
}
